import React from 'react';
import { withGoogleMap, GoogleMap, Marker, Polygon } from 'react-google-maps';
import _ from 'lodash';

// Extract a valid, finite LatLngLiteral from a point
function parsePoint(point) {
    if (!point) return null;
    let lat, lng;
    if (Array.isArray(point)) {
        if (point.length >= 2) {
            lat = parseFloat(point[1]);
            lng = parseFloat(point[0]);
        }
    } else if (typeof point === 'object') {
        const pLat = point.lat !== undefined ? point.lat : point.latitude;
        const pLng = point.lng !== undefined ? point.lng : point.longitude;
        lat = parseFloat(pLat);
        lng = parseFloat(pLng);
    }
    const isValid = typeof lat === 'number' && !isNaN(lat) && isFinite(lat) &&
                    typeof lng === 'number' && !isNaN(lng) && isFinite(lng);
    if (isValid) {
        return { lat, lng };
    }
    // Log invalid coordinates to console for easier debugging
    console.warn('[MapComponent] Invalid or non-finite coordinate detected:', {
        originalPoint: point,
        parsedLat: lat,
        parsedLng: lng
    });
    return null;
}

// return marker coords from port/area
// only first coordinates taken from area polygons
function computeCoords(areasOrCords, type) {
    if (!areasOrCords) {
        return [];
    }
    if (type === 'area') {
        return areasOrCords.map((item) => {
            if (!item) {
                return null;
            }
            let lat, lng;
            if (item.coordinates) {
                lat = parseFloat(item.coordinates[1]);
                lng = parseFloat(item.coordinates[0]);
            } else if (item.areaCoordinatesPolygons && item.areaCoordinatesPolygons.coordinates) {
                const polygon = item.areaCoordinatesPolygons.coordinates[0];
                if (polygon && polygon[0] && polygon[0][0]) {
                    const point = polygon[0][0];
                    lat = parseFloat(point[1]);
                    lng = parseFloat(point[0]);
                }
            }
            const isValid = typeof lat === 'number' && !isNaN(lat) && isFinite(lat) &&
                            typeof lng === 'number' && !isNaN(lng) && isFinite(lng);
            if (isValid) {
                return { lat, lng };
            }
            console.warn('[MapComponent] Filtered out invalid area coordinate:', {
                item,
                parsedLat: lat,
                parsedLng: lng
            });
            return null;
        }).filter(p => p);
    } 
    if (Array.isArray(areasOrCords) && areasOrCords.length >= 2) {
        const lat = parseFloat(areasOrCords[1]);
        const lng = parseFloat(areasOrCords[0]);
        const isValid = typeof lat === 'number' && !isNaN(lat) && isFinite(lat) &&
                        typeof lng === 'number' && !isNaN(lng) && isFinite(lng);
        if (isValid) {
            return [{ lat, lng }];
        }
        console.warn('[MapComponent] Invalid single coordinate pair:', {
            areasOrCords,
            parsedLat: lat,
            parsedLng: lng
        });
    }
    return [];
}

class Map extends React.Component {
    constructor(props) {
        super(props);

        const { coordinates, type, areaPolygon } = props;
        this.state = {
            coordinates: computeCoords(coordinates, type),
            areaPolygon,
        };
    }

    makeBounds() {
        const { coordinates } = this.state;

        if (coordinates.length === 0) {
            return;
        }

        const bounds = new google.maps.LatLngBounds();

        coordinates.forEach((item) => {
            bounds.extend(item);
        });

        if (this.props.type !== 'ports') {
            this.refs.googleMap.fitBounds(bounds);
        }
    }

    componentDidMount() {
        this.makeBounds();
    }

    componentDidUpdate() {
        google.maps.event.trigger(this.refs.googleMap.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, 'resize');
        this.makeBounds();
    }

    UNSAFE_componentWillReceiveProps({ coordinates, type, areaPolygon }) {
        this.setState({
            coordinates: computeCoords(coordinates, type),
            areaPolygon,
        });

        if (areaPolygon) {
            const validPath = areaPolygon.map(parsePoint).filter(p => p);
            if (validPath.length > 0) {
                const poly = new google.maps.Polygon({
                    paths: validPath,
                });

                const bounds = new google.maps.LatLngBounds();
                const paths = poly.getPaths();
                let path;        
                for (let i = 0; i < paths.getLength(); i++) {
                    path = paths.getAt(i);
                    for (let ii = 0; ii < path.getLength(); ii++) {
                        bounds.extend(path.getAt(ii));
                    }
                }

                this.refs.googleMap.fitBounds(bounds);
            }
        }
    }

    render() {
        const { coordinates, areaPolygon } = this.state;
        const { editCoordsMarker } = this.props;
        return (<div>
            {
                <GoogleMap
                    ref='googleMap'
                    defaultZoom={10}
                    zoom={10}
                    defaultCenter={{
                        lat: coordinates[0] ? coordinates[0].lat : 0,
                        lng: coordinates[0] ? coordinates[0].lng : 0,
                    }}
                >
                    {
                        coordinates.map((item, key) => (<Marker
                            key={key}
                            position={{
                                lat: item.lat,
                                lng: item.lng,
                            }}
                        />))
                    }
                    {
                        areaPolygon &&
                        <Polygon 
                            path={areaPolygon.map(parsePoint).filter(p => p)}
                            options={{
                                strokeColor: '#00f',
                                fillColor: '#00f',
                            }}
                        />
                    }
                    {
                        areaPolygon && (editCoordsMarker || editCoordsMarker === 0) &&
                        parsePoint(areaPolygon[editCoordsMarker]) &&
                        <Marker
                            position={parsePoint(areaPolygon[editCoordsMarker])}
                        />
                    }
                </GoogleMap>
            }
        </div>);
    }
}

const MyMapComponent = withGoogleMap(Map);

export default MyMapComponent;



// WEBPACK FOOTER //
// ./app/components/Regions/Merging/Map.jsx